module.exports = __webpack_public_path__ + "img/Frame.2f21b220.svg";